import { render } from "./DataQualityManagement.vue?vue&type=template&id=5524270e&scoped=true"
import script from "./DataQualityManagement.vue?vue&type=script&lang=js"
export * from "./DataQualityManagement.vue?vue&type=script&lang=js"

import "./DataQualityManagement.vue?vue&type=style&index=0&id=5524270e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5524270e"]])

export default __exports__